export const ONBOARDING_EVENTS = {
  ONBOARDING_SUCCESS: 'ONBOARDING_SUCCESS',
  ONBOARDING_FAILURE: 'ONBOARDING_FAILURE',
  COMPANY_TYPES_FETCH_SUCCESS: 'COMPANY_TYPES_FETCH_SUCCESS',
  COMPANY_TYPES_FETCH_FAILURE: 'COMPANY_TYPES_FETCH_FAILURE',
};
